export enum GIFT_CARD_TYPE {
  BASIC = 'basic',
  E_GIFT_CARD = 'egiftcard',
  CONSOLIDATED_MASTER = 'consolidated_master',
}
